import React from "react";
import gql from "graphql-tag";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Badge from "react-bootstrap/Badge";

import { client } from "../index";
import { GET_PROCESS } from "./OcrProcessDisplay";

import { statusToClass, pickStatus } from "./OcrProcessLineItem";
import { IOcrProcessLineItem } from "./OcrProcessDisplay";

import DocumentLightbox from "./DocumentLightbox";

interface OcrProcessLineItemBoxProps {
  item: IOcrProcessLineItem;
  processNumber: string;
}

function statusToIcon(status: number) {
  if (status === 0) {
    return "icon-mail-open";
  }
  if (status === 1) {
    return "icon-mail";
  }
  if (status === 2) {
    return "icon-euro";
  }
  if (status === 3) {
    return "icon-attention-1";
  }
  if (status === 4) {
    return "icon-ok-circled";
  }

  // TODO: Replace with Gavel
  return "icon-minus-squared";
}

export default class OcrProcessLineItemBox extends React.Component<OcrProcessLineItemBoxProps> {
  state: {
    accordionOpen: boolean;
  };

  constructor(props: any) {
    super(props);
    this.state = {
      accordionOpen: false,
    };
  }

  badgeSpan(key: string, tag: string) {
    return (
      <span key={key} className="badge mr-2">
        {" "}
        {tag}
      </span>
    );
  }

  renderThumbs(item: IOcrProcessLineItem) {
    if (item.images === undefined || item.images === null) {
      return "";
    }

    return item.images.map((img, idx) => (
      <DocumentLightbox
        key={`pimg-key-${idx}`}
        likey={`pimg-${idx}`}
        images={item.images}
        photoIndex={idx}
      />
    ));
  }

  humanReadableStatus(status: number) {
    if (status === -1) {
      return "";
    }

    if (status === 1) {
      return "Eingereicht";
    }

    if (status === 2) {
      return "Erstattet";
    }

    if (status === 3) {
      return "Widerspruch";
    }

    if (status === 4) {
      return "Abgeschl.";
    }

    if (status === 5) {
      return "Nachford.";
    }

    if (status === 6) {
      return "Kein Anspruch";
    }

    if (status === 7) {
      return "Begr. Kürzung";
    }

    return "Offen";
  }

  render() {
    const itemStatus = pickStatus(this.props.item);
    const statusString = statusToClass(itemStatus);
    const statusIcon = statusToIcon(itemStatus);
    const hasVUorBH =
      this.props.item.bhStatus !== -1 || this.props.item.vuStatus !== -1;

    return (
      <>
        <div className={`box-leistungsbericht br-lg status--${statusString}`}>
          <div className="indicatorbg" />
          <div className="indicator">
            {this.humanReadableStatus(itemStatus)}{" "}
            <span className={statusIcon} />
          </div>
          <Row>
            <Col>
              <label>B-Nr.</label>
              <div className="lbvalue">{this.props.item.receiptNumber}</div>
            </Col>
            <Col>
              <label>Kostenart</label>
              <div className="lbvalue">{this.props.item.receiptClass}</div>
            </Col>
            <div className="col">
              <label>B-Datum</label>
              <div className="lbvalue">{this.props.item.behandlungsdatum}</div>
            </div>
            <div className="col">
              <label>Leistungserbringer</label>
              <div className="lbvalue" style={{ width: 180 }}>
                {/* Only use careProvider as a fallback as it may reference a different entity. Ensure viewing the "Kontoinhaber" to avoid surprises */}
                {this.props.item.accountHolderName || this.props.item.careProvider}
              </div>
            </div>
            <div className="col">
              <label>R-Betrag</label>
              <div className="lbvalue">{this.props.item.receiptSum}</div>
            </div>
            <div className="col">
              <label>Erstattet</label>
              <div className="lbvalue">{this.props.item.erstattungSum}</div>
            </div>
            <div className="col">
              <label>R-Datum</label>
              <div className="lbvalue">{this.props.item.receiptDate}</div>
            </div>
            <div className="col">
              <label>R-Nr.</label>
              <div className="lbvalue">{this.props.item.extReceiptNumber}</div>
            </div>
            <div className="col">
              <label>Bezahlt?</label>
              <div className="lbvalue">
                {this.props.item.paidByClient
                  ? "Vom Mandant"
                  : this.props.item.paid
                  ? "Ja"
                  : "Nein"}
              </div>
            </div>
            <div className="col">
              <label>bezahlt am</label>
              <div className="lbvalue">
                <span>
                  {this.props.item.paidByClient ? "" : this.props.item.paidOn}
                </span>
                <span
                  className={`icon-${
                    this.props.item.paidOn || this.props.item.paidByClient
                      ? "ok-circled"
                      : "cancel"
                  }`}
                />
              </div>
            </div>
            {hasVUorBH && (
              <>
                <div className="col">
                  <label>
                    Status <abbr title="Versicherungsunternehmen">VU</abbr>
                  </label>
                  <div className="lbvalue">
                    {this.props.item.erstattungVu
                      ? this.props.item.erstattungVu
                      : this.humanReadableStatus(this.props.item.vuStatus)}
                  </div>
                </div>

                <div className="col">
                  <label>
                    Status <abbr title="Beihilfe">BH</abbr>
                  </label>
                  <div className="lbvalue">
                    {this.props.item.erstattungBh
                      ? this.props.item.erstattungBh
                      : this.humanReadableStatus(this.props.item.bhStatus)}
                  </div>
                </div>
              </>
            )}
            {!hasVUorBH && (
              <>
                <div className="col">
                  <label>
                    Status <abbr title="Versicherungsunternehmen">VU</abbr>
                  </label>
                  <div className="lbvalue">
                    {this.humanReadableStatus(this.props.item.status)}
                  </div>
                </div>

                <div className="col">
                  <label>
                    Status <abbr title="Beihilfe">BH</abbr>
                  </label>
                  <div className="lbvalue">
                    {this.humanReadableStatus(this.props.item.status)}
                  </div>
                </div>
              </>
            )}
            {/*
            <div className="col">
              <label>Leistungen&nbsp;PKV/PPV</label>
              <div className="lbvalue">{this.props.item.leistungPkvPpv}</div>
            </div>
            <div className="col">
              <label>Leistung&nbsp;Beihilfe</label>
              <div className="lbvalue">{this.props.item.leistungBeihilfe}</div>
            </div>
            <div className="col">
              <label>Eigenanteil</label>
              <div className="lbvalue">{this.props.item.eigenanteil}</div>
            </div>
                */}
          </Row>
          {this.props.item.images && (
            <Row>
              <Col>
                <Accordion>
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    eventKey="0"
                    onClick={() =>
                      this.setState({
                        ...this.state,
                        accordionOpen: !this.state.accordionOpen,
                      })
                    }
                  >
                    {this.state.accordionOpen && (
                      <>
                        <span className="icon-down-open fs-075 ml-1" />
                        Belege verbergen
                      </>
                    )}
                    {!this.state.accordionOpen && (
                      <>
                        <span className="icon-right-open fs-075 ml-1" />
                        Belege anzeigen
                      </>
                    )}
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Container fluid>
                      <Row>
                        <>{this.renderThumbs(this.props.item)}</>
                      </Row>
                    </Container>
                  </Accordion.Collapse>
                </Accordion>
              </Col>
            </Row>
          )}
        </div>
      </>
    );
  }
}
